export type ChangedLine = { type: "same" | "added" | "removed"; text: string };
/** Line LCS with bounded memory; large documents retain shared ends without quadratic work. */
export function lineChanges(before: string, after: string): ChangedLine[] {
  const a = before.split("\n"), b = after.split("\n");
  let prefix = 0;
  while (prefix < a.length && prefix < b.length && a[prefix] === b[prefix]) prefix++;
  let suffix = 0;
  while (suffix < a.length - prefix && suffix < b.length - prefix && a[a.length - suffix - 1] === b[b.length - suffix - 1]) suffix++;
  const x = a.slice(prefix, a.length - suffix), y = b.slice(prefix, b.length - suffix);
  const result: ChangedLine[] = a.slice(0, prefix).map((text) => ({ type: "same", text }));
  if (x.length * y.length > 500_000) {
    result.push(...x.map((text): ChangedLine => ({ type: "removed", text })), ...y.map((text): ChangedLine => ({ type: "added", text })));
  } else {
    const width = y.length + 1, dp = new Uint32Array((x.length + 1) * width);
    for (let i = x.length - 1; i >= 0; i--) for (let j = y.length - 1; j >= 0; j--) dp[i * width + j] = x[i] === y[j] ? dp[(i + 1) * width + j + 1]! + 1 : Math.max(dp[(i + 1) * width + j]!, dp[i * width + j + 1]!);
    let i = 0, j = 0;
    while (i < x.length || j < y.length) {
      if (i < x.length && j < y.length && x[i] === y[j]) { result.push({ type: "same", text: x[i++]! }); j++; }
      else if (i < x.length && (j === y.length || dp[(i + 1) * width + j]! >= dp[i * width + j + 1]!)) result.push({ type: "removed", text: x[i++]! });
      else result.push({ type: "added", text: y[j++]! });
    }
  }
  return result.concat(a.slice(a.length - suffix).map((text) => ({ type: "same", text })));
}
